import React, { useEffect, useState } from "react";
import { api, fmtDate, priorityClass } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { AlertCircle, Calendar, CheckCircle2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Tasks() {
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  const load = async () => { const r = await api.get("/tasks"); setRows(r.data); };
  useEffect(() => { load(); }, []);
  const today = new Date().toISOString().slice(0,10);
  const weekAhead = new Date(Date.now()+7*86400000).toISOString().slice(0,10);
  const overdue = rows.filter(t => t.status !== "Done" && t.due_date < today);
  const dueToday = rows.filter(t => t.status !== "Done" && t.due_date === today);
  const dueWeek = rows.filter(t => t.status !== "Done" && t.due_date > today && t.due_date <= weekAhead);

  return (
    <div className="space-y-6">
      <div><h1 className="heading-font text-3xl font-bold text-slate-900">Tasks &amp; Follow-ups</h1><p className="text-sm text-slate-500 mt-1">Never miss a partner or student follow-up.</p></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Bucket icon={AlertCircle} tone="red" label="Overdue" tasks={overdue} nav={nav} reload={load} />
        <Bucket icon={Calendar} tone="orange" label="Due Today" tasks={dueToday} nav={nav} reload={load} />
        <Bucket icon={CheckCircle2} tone="blue" label="Due This Week" tasks={dueWeek} nav={nav} reload={load} />
      </div>
    </div>
  );
}

function Bucket({ icon: Icon, tone, label, tasks, nav, reload }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200">
      <div className={`p-4 flex items-center justify-between border-b border-slate-100`}>
        <div className="flex items-center gap-2"><Icon className={`w-5 h-5 text-${tone}-500`} /> <span className="heading-font font-semibold">{label}</span></div>
        <span className={`stage-badge bg-${tone}-50 text-${tone}-900 border-${tone}-300`}>{tasks.length}</span>
      </div>
      <div className="divide-y divide-slate-100">
        {tasks.map(t => (
          <div key={t.id} className="p-4">
            <div className="flex items-center justify-between gap-2">
              <button onClick={()=>t.application_id && nav(`/applications/${t.application_id}`)} className="text-sm font-medium text-slate-900 text-left hover:text-orange-600">{t.title}</button>
              <span className={`stage-badge ${priorityClass(t.priority)}`}>{t.priority}</span>
            </div>
            <div className="text-xs text-slate-500 mt-1">Due {fmtDate(t.due_date)}</div>
            <Select value={t.status} onValueChange={async v => { await api.patch(`/tasks/${t.id}`, { status: v }); reload(); }}>
              <SelectTrigger className="mt-2 h-8"><SelectValue /></SelectTrigger>
              <SelectContent>{["Open","In Progress","Done","Cancelled"].map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        ))}
        {tasks.length === 0 && <div className="p-6 text-center text-slate-400 text-sm">Nothing here.</div>}
      </div>
    </div>
  );
}
